export enum RepairServiceLocalStorage {
  KEY = 'repairServiceFilterKey',
  STATUS = 'repairServiceFilterStatus',
}
